var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ma-8 pt-8"},[_c('products',{attrs:{"exclude-required":""},on:{"click:product":function (product) {
        _vm.$router.push({ name: 'product', params: { id: product.getId() } })
      }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }